var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 31.953125 175.832031 L 70.351562 175.832031 L 70.351562 140.917969 L 31.953125 140.917969 Z M 31.953125 175.832031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 370.070312 172.59375 C 370.941406 171.121094 373.898438 164.828125 375 162.535156 L 367.28125 157.296875 L 367.28125 157.3125 C 358.914062 151.613281 339.621094 149.550781 324.808594 152.371094 C 322.886719 138.253906 315.109375 125.964844 300.929688 114.917969 L 292.792969 109.449219 L 287.386719 117.675781 C 276.695312 134.023438 273.796875 160.941406 285.246094 178.699219 C 280.195312 181.457031 270.261719 185.222656 257.121094 184.988281 L 4.539062 184.988281 C -0.511719 214.851562 7.917969 253.652344 30.109375 280.289062 C 51.648438 306.105469 83.957031 319.214844 126.199219 319.214844 C 217.65625 319.214844 285.339844 276.601562 317.015625 199.167969 C 329.441406 199.402344 356.296875 199.230469 370.070312 172.59375 Z M 370.070312 172.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 77.277344 140.917969 L 115.675781 140.917969 L 115.675781 175.832031 L 77.277344 175.832031 Z M 77.277344 140.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 122.664062 140.917969 L 161.0625 140.917969 L 161.0625 175.832031 L 122.664062 175.832031 Z M 122.664062 140.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 213.472656 140.917969 L 251.871094 140.917969 L 251.871094 175.832031 L 213.472656 175.832031 Z M 213.472656 140.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 77.277344 98.523438 L 115.675781 98.523438 L 115.675781 133.851562 L 77.277344 133.851562 Z M 77.277344 98.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 168.039062 140.980469 L 206.4375 140.980469 L 206.4375 175.894531 L 168.039062 175.894531 Z M 168.039062 140.980469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 168.039062 98.523438 L 206.4375 98.523438 L 206.4375 133.851562 L 168.039062 133.851562 Z M 168.039062 98.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 168.039062 55.785156 L 206.4375 55.785156 L 206.4375 91.472656 L 168.039062 91.472656 Z M 168.039062 55.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8ff",
    d: "M 122.664062 98.523438 L 161.0625 98.523438 L 161.0625 133.851562 L 122.664062 133.851562 Z M 122.664062 98.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.74be3fc1365624fd518c52ef5df770e0.svg";
export { ForwardRef as ReactComponent };